// StatusBadge.tsx
import React from "react";

type Props = {
  status: string | number;
  label?: string; // Optional text override
  className?: string; // Optional custom class override
};

const StatusBadge: React.FC<Props> = ({ status, label, className }) => {
  let baseClass = "btn btn-sm fw-bold w-125px pointer-events-none mx-2 p-1";
  let badgeClass = className || "";
  let text = label || "";

  switch (status) {
    case "0":
    case "2":
    case "approved":
      badgeClass = className || "btn-success";
      text = label || "Published";
      break;

    case "1":
    case "hidden":
      badgeClass = className || "btn-warning";
      text = label || "Hidden";
      break;

    case "rejected":
      badgeClass = className || "btn-danger";
      text = label || "Rejected";
      break;

    case "pending":
      badgeClass = className || "btn-secondary";
      text = label || "Pending";
      break;

    default:
      badgeClass = className || "";
      text = label || "";
      break;
  }

  return <span className={`${baseClass} ${badgeClass}`}>{text}</span>;
};

export default StatusBadge;
